// ===========================================
// CONFIGURAÇÃO DE AMBIENTE - CLIENTE
// JA FOI DELIVERY - Sistema de Menu Digital
// ===========================================

// Detectar ambiente
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

// Configuração baseada no ambiente
export const config = {
  // ===========================================
  // CONFIGURAÇÕES GERAIS
  // ===========================================
  app: {
    name: 'JA FOI DELIVERY',
    version: '1.0.0',
    environment: process.env.NODE_ENV || 'development',
    isDevelopment,
    isProduction
  },

  // ===========================================
  // CONFIGURAÇÕES DE API
  // Em produção usa URL relativa (mesmo host) para funcionar por IP ou domínio com Nginx
  // ===========================================
  api: {
    baseUrl: isDevelopment 
      ? 'http://localhost:4001' 
      : '', // vazio = mesmo host; Nginx faz proxy de /api/ para o backend
    timeout: 30000,
    retryAttempts: 3
  },

  // ===========================================
  // CONFIGURAÇÕES DE URLS
  // ===========================================
  urls: {
    base: isDevelopment 
      ? 'http://localhost:4000' 
      : (typeof window !== 'undefined' ? window.location.origin : 'https://finansys.site'),
    admin: isDevelopment 
      ? 'http://localhost:4000/admin' 
      : (typeof window !== 'undefined' ? `${window.location.origin}/admin` : 'https://finansys.site/admin'),
    api: isDevelopment 
      ? 'http://localhost:4001' 
      : '' // vazio = mesmo host; Nginx encaminha /api/ para o backend
  },

  // ===========================================
  // CONFIGURAÇÕES DO MERCADO PAGO
  // ===========================================
  mercadoPago: {
    publicKey: isDevelopment
      ? 'APP_USR-0949ed6e-2fbd-4afc-b64c-2dee4fe7506f' // Chave de desenvolvimento
      : 'APP_USR-0949ed6e-2fbd-4afc-b64c-2dee4fe7506f', // Chave de produção
    locale: 'pt-BR',
    currency: 'BRL'
  },

  // ===========================================
  // CONFIGURAÇÕES DO STRIPE
  // ===========================================
  stripe: {
    publishableKey: isDevelopment
      ? 'pk_test_51RlCTeIdpuoqMD04CwtmqOLTOSdd4s7aetWKQEjZm6An7O1dIU5RtDZ4Pq4RjnQ0SezPzfxhIUBriHXz8tSJPnzfxhIUBriHXz8tSJPnry00twae1s5P'
      : 'pk_live_SUA_CHAVE_PUBLICA_STRIPE_AQUI'
  },

  // ===========================================
  // CONFIGURAÇÕES DE UPLOAD
  // ===========================================
  upload: {
    maxSize: isDevelopment ? 5 * 1024 * 1024 : 10 * 1024 * 1024, // 5MB dev, 10MB prod
    allowedTypes: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
    quality: isDevelopment ? 0.8 : 0.9
  },

  // ===========================================
  // CONFIGURAÇÕES DE CACHE
  // ===========================================
  cache: {
    enabled: isProduction,
    ttl: isDevelopment ? 300 : 600, // 5min dev, 10min prod
    maxSize: isDevelopment ? 50 : 100 // MB
  },

  // ===========================================
  // CONFIGURAÇÕES DE LOGS
  // ===========================================
  logging: {
    level: isDevelopment ? 'debug' : 'error',
    console: isDevelopment,
    remote: isProduction
  },

  // ===========================================
  // CONFIGURAÇÕES DE ANALYTICS
  // ===========================================
  analytics: {
    enabled: isProduction,
    googleAnalyticsId: isProduction ? 'GA_MEASUREMENT_ID' : '',
    hotjarId: isProduction ? 'HOTJAR_ID' : ''
  },

  // ===========================================
  // CONFIGURAÇÕES DE PERFORMANCE
  // ===========================================
  performance: {
    lazyLoading: true,
    imageOptimization: true,
    bundleAnalysis: isDevelopment,
    serviceWorker: isProduction
  },

  // ===========================================
  // CONFIGURAÇÕES DE SEGURANÇA
  // ===========================================
  security: {
    cspEnabled: isProduction,
    xssProtection: true,
    secureCookies: isProduction
  }
};

// ===========================================
// FUNÇÕES UTILITÁRIAS
// ===========================================

// Função para obter URL completa da API
export const getApiUrl = (endpoint: string): string => {
  const baseUrl = config.api.baseUrl;
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
};

// Função para obter URL completa de imagem
export const getImageUrl = (imagePath: string): string => {
  if (!imagePath) return '';
  
  const baseUrl = config.api.baseUrl;
  const cleanPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  return `${baseUrl}${cleanPath}`;
};

// Função para verificar se é ambiente de desenvolvimento
export const isDev = (): boolean => config.app.isDevelopment;

// Função para verificar se é ambiente de produção
export const isProd = (): boolean => config.app.isProduction;

// Função para obter configuração de ambiente
export const getEnvironment = (): string => config.app.environment;

// Função para log condicional
export const log = {
  debug: (...args: any[]) => {
    if (config.logging.level === 'debug') {
      console.log('[DEBUG]', ...args);
    }
  },
  info: (...args: any[]) => {
    if (['debug', 'info'].includes(config.logging.level)) {
      console.info('[INFO]', ...args);
    }
  },
  warn: (...args: any[]) => {
    if (['debug', 'info', 'warn'].includes(config.logging.level)) {
      console.warn('[WARN]', ...args);
    }
  },
  error: (...args: any[]) => {
    console.error('[ERROR]', ...args);
  }
};

export default config;